import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  breadcrumbsWrapper: (props: any) => ({
    display: 'flex',
    alignItems: 'stretch',
    height: '44px',
    borderRadius: '5px',
    color: props.primaryColor,
    boxShadow: '0px 0px 3px 0px #d2d2d2',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100vw - 40px)',
    '& .active-text': {
      fontWeight: 'bold',
      [theme.breakpoints.between('lg', 'xl')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '18px',
        lineHeight: '24px',
      },
    },
    [theme.breakpoints.up('xl')]: {
      height: '60px',
    },
    [theme.breakpoints.down('md')]: {
      height: '40px',
      fontSize: '11px',
    },
  }),
  chooseSegment: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
    borderRadius: '5px',
    background: 'rgba(255, 255, 255, 0.80)',
    [theme.breakpoints.up('xl')]: {
      padding: '0 28px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 16px',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '20px',
      bottom: '-9px',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderTop: '9px solid rgba(255, 255, 255, 0.80)',
    },
  },
  backSegment: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    cursor: 'pointer',
    borderRadius: '5px 0 0 5px',
    background: 'rgba(255, 255, 255, 0.80)',
    transition: 'background 0.2s ease',
    '&:hover': {
      background: 'rgba(255, 255, 255, 1)',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '10px 28px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '8px 12px',
      maxWidth: '50%',
      '& .active-text': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    flexShrink: 0,
  },
  chevronIcon: {
    display: 'block',
  },
  currentSegment: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    overflow: 'hidden',
    padding: '10px 16px',
    borderRadius: '0 5px 5px 0',
    background: 'rgba(255, 255, 255, 0.60)',
    [theme.breakpoints.up('xl')]: {
      padding: '10px 28px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '8px 12px',
    },
    '& .active-text': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  dot: (props: any) => ({
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: props.primaryColor,
  }),
}));
